import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: () => import('../views/index')
  // },
  {
    path: '/',
    name: 'App',
    component: () => import('../views/app/index')
  },
  {
    path: '/service',
    name: 'Service',
    component: () => import('../views/app/service')
  },
  {
    path: '/roaming-charge',
    name: 'RoamingCharge',
    component: () => import('../views/app/roaming-charge')
  },
  {
    path: '/top-up',
    name: 'Topup',
    component: () => import('../views/app/top-up')
  },
  {
    path: '/order',
    name: 'Order',
    component: () => import('../views/app/order')
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('../views/app/account')
  },
  {
    path: '/channel',
    name: 'channel',
    component: () => import('../views/app/channel')
  },
  {
    path: '/channel-partner',
    name: 'channelPartner',
    component: () => import('../views/app/channel-partner')
  },
  {
    path: '/channel-submit-history',
    name: 'channelPartnerHistroy',
    component: () => import('../views/app/channel-submit-history')
  },
  {
    path: '/channel-reg',
    name: 'channel_reg',
    component: () => import('../views/app/channel-reg')
  },
  {
    path: '/esim-intro',
    name: 'channel_reg',
    component: () => import('../views/app/esim-intro')
  },
  {
    path: '/channel-submit',
    name: 'channelsubmit',
    component: () => import('../views/app/channel-submit')
  },
  {
    path: '/channel_code_desc',
    name: 'channel_code_desc',
    component: () => import('../views/app/channel_code_desc')
  },
  {
    path: '/auth-login',
    name: 'login',
    component: () => import('../views/auth-login')
  },
  {
    path: '/auth-signup',
    name: 'signup',
    component: () => import('../views/auth-signup')
  },
  {
    path: '/auth-re-password',
    name: 'reset-password',
    component: () => import('../views/auth-re-password')
  },
  {
    path: '/page-terms',
    name: 'terms',
    component: () => import('../views/page-terms')
  },
  {
    path: '/page-terms-use',
    name: 'page-terms-use',
    component: () => import('../views/page-term-of-use.vue')
  },
  {
    path: '/page-website-disclaimer',
    name: 'page-website-disclaimer',
    component: () => import('../views/page-website-disclaimer.vue')
  },
  {
    path: '/page-privacy',
    name: 'privacy',
    component: () => import('../views/page-privacy')
  },
  {
    path: '*',
    component: () => import('../views/page-error')
  },
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
